import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/ArrowDown';
import s from './WidgetNavMenu.scss';

export interface Props {
  className?: string;
  widgetMenuItemsList: {
    transKey: string;
    hash: string;
  }[];
}

export class WidgetNavMenu extends React.Component<Props & WithTranslation> {
  selectElementRef: any;

  render() {
    const { widgetMenuItemsList, t } = this.props;
    return (
      <>
        <ArrowDownIcon className={s['arrow-icon']} withPadding={false} />
        <select
          className={s['select']}
          ref={this.saveSelectRef}
          onChange={this.navigateToHash}
        >
          {widgetMenuItemsList &&
            widgetMenuItemsList.map((item, key) => {
              return (
                <option key={key} value={key}>
                  {t(item.transKey)}
                </option>
              );
            })}
        </select>
      </>
    );
  }

  saveSelectRef = ref => {
    this.selectElementRef = ref;
  };

  navigateToHash = value => {
    const { widgetMenuItemsList: menu } = this.props;
    const selectedItem = menu && menu[Number(this.selectElementRef.value)];
    const hash = selectedItem.hash;
    if (hash && document.location) {
      document.location.hash = hash;
    }
    this.selectElementRef.value = '';
  };
}

export default withTranslation()(WidgetNavMenu);
